<template>
    <div>
      <div class="case" ref="box">
        <img class="caseimg1" src="../assets/images/table_caigoufukuan.png">
        <div class="caseword">
          <p class="Shenqingbumen">{{Shenqingbumen}}</p>
          <p class="Tianzhiriqi">{{Tianzhiriqi}}</p>
          <p class="Shoukuandanwei">{{Shoukuandanwei}}</p>
          <p class="Orderid">{{Orderid}}</p>
          <p class="Yinghangzhanghao">{{Yinghangzhanghao}}</p>
          <p class="Kaihuhang">{{Kaihuhang}}</p>
          <p class="Fukuanyuanyin">{{Fukuanyuanyin}}</p>
          <p class="Money">{{Money}}</p>
          <p class="Jingbanren">{{Jingbanren}}</p>
          <p class="Bumenzhuguan">{{Bumenzhuguan}}</p>
          <p class="Caiwu">{{Caiwu}}</p>
          <p class="Fuzongjingli">{{Fuzongjingli}}</p>
          <p class="Zongjingli">{{Zongjingli}}</p>
          <p class="Chuna">{{Chuna}}</p>
        </div>
      </div>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      Shenqingbumen: '',
      Tianzhiriqi: '',
      Shoukuandanwei: '',
      Orderid: '',
      Yinghangzhanghao: '',
      Kaihuhang: '',
      Fukuanyuanyin: '',
      Money: '',
      Jingbanren: '',
      Bumenzhuguan: '',
      Caiwu: '',
      Fuzongjingli: '',
      Zongjingli: '',
      Chuna: ''
    }
  },
  mounted () {
  },
  methods: {
    InitData(){
      this.Shenqingbumen = ''
      this.Tianzhiriqi = ''
      this.Shoukuandanwei = ''
      this.Orderid = ''
      this.Yinghangzhanghao = ''
      this.Kaihuhang = ''
      this.Fukuanyuanyin = ''
      this.Money = ''
      this.Jingbanren = ''
      this.Bumenzhuguan = ''
      this.Caiwu = ''
      this.Fuzongjingli = ''
      this.Zongjingli = ''
      this.Chuna = ''
    },
    LoadData (parentdata,forprint) {
      this.InitData()
      var that = this
      this.$nextTick(() => {
        that.Shenqingbumen = parentdata.CurJigouName
        that.Tianzhiriqi = Vue.prototype.SplitTimeString(parentdata.Createtime)
        that.Shoukuandanwei = parentdata.Shoukuandanwei
        that.Orderid = parentdata.Orderidcaigou
        that.Yinghangzhanghao = parentdata.Yinhangzhanghao
        that.Kaihuhang = parentdata.Kaihuhang
        that.Fukuanyuanyin = parentdata.Reason
        that.Money = parentdata.Money
        that.Jingbanren = parentdata.Name1
        that.Bumenzhuguan = parentdata.Name2
        that.Caiwu = parentdata.Name3
        that.Fuzongjingli = parentdata.Name4
        that.Zongjingli = parentdata.Name5
        if(forprint == 0){
          that.Chuna = ''
        } else {
          that.Chuna = localStorage.getItem('Nicename')
        }
      });
    },
  }
}
</script>

<style lang="less" scoped>
.case{
    width: 839px;
    height: 298px;
    position: relative;
}

.caseimg1{
  width: 839px;
  height: 298px;
  position: absolute;
  z-index: 10;
}

.caseword{
  color:#000000;
  font-size: 14px;
}

.Shenqingbumen{
  position: absolute;
  z-index: 30;
  left: 80px;
  top: 25px;
}

.Tianzhiriqi{
  position: absolute;
  z-index: 30;
  left: 495px;
  top: 25px;
}

.Shoukuandanwei{
  position: absolute;
  z-index: 30;
  left: 80px;
  top: 59px;
}

.Orderid{
  position: absolute;
  z-index: 30;
  left: 495px;
  top: 59px;
}

.Yinghangzhanghao{
  position: absolute;
  z-index: 30;
  left: 80px;
  top: 93px;
}

.Kaihuhang{
  position: absolute;
  z-index: 30;
  left: 80px;
  top: 127px;
}

.Fukuanyuanyin{
  position: absolute;
  z-index: 30;
  left: 80px;
  top: 161px;
  right: 5px;
  word-wrap: break-word;
  word-break: break-all;
}

.Money{
  position: absolute;
  z-index: 30;
  left: 80px;
  top: 223px;
}

.Jingbanren{
  position: absolute;
  z-index: 30;
  left: 74px;
  top: 257px;
}

.Bumenzhuguan{
  position: absolute;
  z-index: 30;
  left: 214px;
  top: 257px;
}

.Caiwu{
  position: absolute;
  z-index: 30;
  left: 350px;
  top: 257px;
}

.Fuzongjingli{
  position: absolute;
  z-index: 30;
  left: 488px;
  top: 257px;
}

.Zongjingli{
  position: absolute;
  z-index: 30;
  left: 625px;
  top: 257px;
}

.Chuna{
  position: absolute;
  z-index: 30;
  left: 770px;
  top: 257px;
}
</style>
